import { Reglaments } from './Reglaments';

export default Reglaments;
